import { render } from "./link.vue?vue&type=template&id=37db6188&scoped=true"
import script from "./link.vue?vue&type=script&lang=js"
export * from "./link.vue?vue&type=script&lang=js"

import "./link.vue?vue&type=style&index=0&id=37db6188&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37db6188"]])

export default __exports__